export default {"src":"/_next/static/media/MenuBgImage1.76621497.svg","height":170,"width":291,"blurWidth":0,"blurHeight":0};